import React from 'react';

import Stack from '~/common/components/Stacks/Stack';

type VStackProps = Omit<React.ComponentProps<typeof Stack>, 'direction'>;

const VStack = React.forwardRef<any, VStackProps>(
  ({ children, ...props }, ref) => {
    return (
      <Stack direction="column" spacing={2} ref={ref} {...props}>
        {children}
      </Stack>
    );
  },
);

VStack.displayName = 'VStack';

export default VStack;
